import React from 'react';

const LoadingView = () => (
  <div>
    <div className="loading">
      <i />
    </div>
  </div>
);

export default LoadingView;
